import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Form, Input, Button, Spin, DatePicker } from "antd";
import {
  MISSATGE_CAMP_OBLIGATORI,
  MISSATGE_BAIXA_INDRET_ERROR,
  MISSATGE_BAIXA_INDRET_OK,
  MISSATGE_BAIXA_INDRET_TITOL,
  MISSATGE_SPIN_BAIXA_INDRET,
  TITOL_BAIXA_INDRET
} from "../../constantsFormularis";
import styles from "./IndretFormulariDonarBaixa.module.css";
import { NotificacioExit } from "../Notification";
import { fetchDonarBaixaIndret } from "../../actions/consultesServidor";
import * as rutes from "../../routes";
import { getDadesIndret } from "../../reducers";
import { setTitolApartat, errorConsultaServidor } from "../../actions";
import { MASCARA_DDMMYYYY, convertirTextAMomentLocal } from "../../utils/dates";
import { rutaIndrets } from "../../routes";

class IndretFormulariDonarBaixa extends Component {
  state = {
    canviEnCurs: false
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_BAIXA_INDRET);
  }

  setCanviEnCurs = value => {
    this.setState({ canviEnCurs: value });
  };

  getNomObservador = indret => {
    return indret ? indret.nomObservador : "";
  };

  getNomIndret = indret => {
    return indret ? indret.nom : "";
  };

  handleCanvi = e => {
    this.setCanviEnCurs(true);
    e.preventDefault();
    const { dadesIndret, form, history } = this.props;
    const idIndret = dadesIndret.id;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const dataSeleccionada = convertirTextAMomentLocal(
          values.dataSeleccionada
        ).format(MASCARA_DDMMYYYY);

        fetchDonarBaixaIndret(
          idIndret,
          dataSeleccionada,
          values.motiubaixa
        ).then(
          dadesResultat => {
            form.resetFields();
            this.setCanviEnCurs(false);
            dadesResultat && dadesResultat.message
              ? this.props.errorConsultaServidor(
                  dadesResultat.titol,
                  dadesResultat.message
                )
              : dadesResultat
                ? NotificacioExit(
                    MISSATGE_BAIXA_INDRET_TITOL,
                    MISSATGE_BAIXA_INDRET_OK
                  )
                : this.props.errorConsultaServidor(
                    MISSATGE_BAIXA_INDRET_TITOL,
                    MISSATGE_BAIXA_INDRET_ERROR
                  );
            history.push({
              pathname: rutaIndrets
            });
          },
          error => {
            this.setCanviEnCurs(false);
            this.props.errorConsultaServidor(
              error,
              error.titol ? error.titol : MISSATGE_BAIXA_INDRET_ERROR
            );
          }
        );
      }

      this.setCanviEnCurs(false);
    });
  };

  render() {
    const { form, dadesIndret } = this.props;
    const { getFieldDecorator } = form;
    const nomObservador = this.getNomObservador(dadesIndret);
    const nomIndret = this.getNomIndret(dadesIndret);
    const { TextArea } = Input;

    return (
      <Spin
        spinning={this.state.canviEnCurs}
        tip={MISSATGE_SPIN_BAIXA_INDRET}
        delay={0}
      >
        <div>
          <div className={styles.baixa_form}>
            <div>
              <span className={styles.campTitol}>{"Observador: "}</span>
              {nomObservador}
            </div>
            <div>
              <span className={styles.campTitol}>{"Indret: "}</span>
              {nomIndret}
            </div>

            <Form layout="vertical" onSubmit={this.handleCanvi}>
              <Form.Item
                label="Seleccionar la data de baixa"
                className={styles.label}
              >
                {getFieldDecorator("dataSeleccionada", {
                  rules: [
                    {
                      type: "object",
                      required: true,
                      message: "Aquest camp és obligatori"
                    }
                  ]
                })(
                  <DatePicker
                    placeholder="Seleccionar data"
                    format={MASCARA_DDMMYYYY}
                  />
                )}
              </Form.Item>
              <Form.Item label="Motiu baixa" className={styles.label}>
                {getFieldDecorator("motiubaixa", {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI
                    }
                  ]
                })(<TextArea rows={4} />)}
              </Form.Item>

              <Button type="primary" htmlType="submit" size="large">
                Guardar
              </Button>

              <Link
                className={styles.botoTornar}
                to={{
                  pathname: rutes.rutaDetallIndret,
                  query: { render: false }
                }}
              >
                <Button icon="left">Tornar</Button>
              </Link>
            </Form>
          </div>
        </div>
      </Spin>
    );
  }
}

IndretFormulariDonarBaixa.propTypes = {
  dadesIndret: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    dadesIndret: getDadesIndret(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor
};

const WrappedNormalBaixaForm = Form.create({ name: "baixa_indret" })(
  IndretFormulariDonarBaixa
);

export default connect(mapStateToProps, mapDispatchToProps)(
  WrappedNormalBaixaForm
);
